module.exports = __webpack_public_path__ + "static/media/leafnet-logo.3af5e75f.jpg";